<template>
  <div :class="[
    'mask-img',
    {
      'mask-img-m': isMobile
    }
  ]">
    <div id="container" :class="['container', calculateLength(lessonInfo.lessonName.length) > 34 ? 'higher': '']">
      <img
        v-if="canvasImgUrl"
        crossorigin='anonymous'
        :src="canvasImgUrl"
        class="save-img"
      >
    </div>
    <p v-if="isMobile" class="tip-text">{{ $t('publesson.downloadImg.save') }}</p>
    <i class="eeo-icon-circle-close close"  @click="hideMask"></i>

    <div style="overflow: hidden; width: 0px; height: 0px;">
      <canvas
        ref="QRImageCanvas"
        id="myCanvas"
        width="1120px"
        height="1624px"
      >
        The device is not supported canvas.
      </canvas>
    </div>
  </div>
</template>

<script>
import moment_format from '@/filters/moment_format';
import serverimg_url from '@/filters/serverimg_url';
export default {
  name: 'mask-box',
  props: {
    lessonInfo: {
      type: Object,
      default: ()=>{}
    },
    publessonId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isMobile: window.browserVersion.mobile,
      errorImg: 'this.src="' + require('@/assets/images/k/avatar_defalut.png') + '"',
      canvasImgUrl: '',
      errorCanvasImg: require('@/assets/images/b/avatar_defalut.png'),
    }
  },
  computed: {
    lessonStartTime() {
      const lessonTime = this.lessonInfo.lessonStartTime ? moment_format(this.lessonInfo.lessonStartTime, 'YYYY/MM/DD HH:mm') : '--'
      return lessonTime
    },
    imgSrc() {
      let url = `https://${window.EEOENV.share.main}/s/k/?sn=${this.publessonId}`
      var encodeValue = encodeURIComponent(url)
      var srcStr =
        'https://' +
        window.EEOENV.hosts.dynamic +
        '/import/code/qrimg.php?size=6&level=L&tourl=' +
        encodeValue
      return srcStr
    },

  },
  filters: {
    serverimg_url,
    moment_format,
  },
  mounted() {
    this.$nextTick(()=>{
      this.drawImage()
    })
  },
  methods: {
    hideMask() {
      this.$emit('hide-mask')
    },
    drawImage() {
      const _this = this
      CanvasRenderingContext2D.prototype.render = function(
        textStr,
        config,
        isLine,
        isCut
      ) {
        var context = this
        var textStyle = {
          fontFamily:
            '\'Microsoft YaHei\', \'微软雅黑\', \'PingFang SC\', \'Helvetica Neue\', Helvetica, \'Hiragino Sans GB\', Arial, sans-serif',
          fontSize: '12px',
          color: '#000',
          textAlign: 'center',
          lineHeight: '12px',
        }
        var boxStyle = {
          width: 0,
          left: 0,
          top: 0,
        }
        if (config) {
          config.fontFamily !== undefined &&
            (textStyle.fontFamily = config.fontFamily)
          config.fontSize !== undefined &&
            ((textStyle.fontSize = config.fontSize),
            (textStyle.lineHeight = config.fontSize))
          config.color !== undefined && (textStyle.color = config.color)
          config.textAlign !== undefined &&
            (textStyle.textAlign = config.textAlign)
          config.lineHeight !== undefined &&
            (textStyle.lineHeight = config.lineHeight)

          config.width !== undefined && (boxStyle.width = config.width)
          config.left !== undefined && (boxStyle.left = config.left)
          config.top !== undefined && (boxStyle.top = config.top)
        }
        var textStrArr = textStr.split('\n')
        var textLineArr = []
        textStrArr.map(function(lineStr) {
          if (isLine) {
            var lineStrArr = lineStr.split('')
            var prevLine = ''
            var testLine = ''
            let moreLen = false
            lineStrArr.map(function(v2, i2) {
              testLine = prevLine + v2
              var testLineWidth = context.measureText(testLine).width
              if (i2 > 0 && testLineWidth > boxStyle.width) {
                moreLen = true
                if (!isCut) {
                  textLineArr.push(prevLine)
                  prevLine = v2
                }
              } else {
                prevLine = testLine
              }
            })
            if (isCut && moreLen) {
              prevLine = prevLine + '...'
            }
            textLineArr.push(prevLine)
          } else {
            textLineArr.push(lineStr)
          }
        })
        var lineHeightNum = parseInt(textStyle.lineHeight)
        let top = boxStyle.top - ((textLineArr.length - 1) * lineHeightNum) / 2

        textLineArr.map(function(v, i) {
          context.font = textStyle.fontSize + ' ' + textStyle.fontFamily
          context.fillStyle = textStyle.color
          context.textAlign = textStyle.textAlign
          context.textBaseline = 'top'

          context.fillText(v, boxStyle.left, top + lineHeightNum * i)
        })
      }
      // const canvas = document.getElementById('myCanvas')
      const canvas = this.$refs.QRImageCanvas
      if (canvas && canvas.getContext) {
        const ctx = canvas.getContext('2d')
        const topImg = require('@/assets/images/k/top.png')
        const len = this.calculateLength(this.lessonInfo.lessonName)
        const ctxHeight = len > 30 ? 858*2 : 812*2
        canvas.height = ctxHeight
        const lessonImg = this.lessonInfo.courseLogo
          ? serverimg_url(this.lessonInfo.courseLogo, '', 'avatar') + '?c=1'
          : this.errorCanvasImg
        ctx.fillStyle="#ffffff";
        ctx.fillRect(0, 0, 560*2, ctxHeight);

        const _topImg = new Image()
        _topImg.crossOrigin = 'Anonymous'
        _topImg.src = topImg
        _topImg.onload = () => {
          ctx.drawImage(_topImg, 0,0,560*2,226*2)
          ctx.save();
          ctx.globalCompositeOperation = 'source-over'
          const _lessonImg = new Image()
          _lessonImg.crossOrigin = 'Anonymous'
          _lessonImg.src = lessonImg
          _lessonImg.onerror = () => {
             _lessonImg.src = this.errorCanvasImg
          }
          _lessonImg.onload = () => {
            // 绘制用户头像（圆形头像）
            //_lessonImg ctx.arc(281, 226, 45, 0, 2 * Math.PI);    //剪切操作 将正方形的头像切成圆的
            // // 从画布上裁剪出这个圆形
            // ctx.clip();
            // ctx.drawImage(_lessonImg, 236, 181, 90, 90)
            // ctx.restore();

            const textMaxWidth = 496*2
            // 绘制title
            ctx.font = '500 32px PingFang SC'
            const cutStr = this.cutStr(this.lessonInfo.lessonName, 30)
            const firstLine = len > 30 ? cutStr : this.lessonInfo.lessonName
            ctx.render(
              firstLine,
              {
                fontSize: '64px',
                color: '#000',
                lineHeight: '72px',
                textAlign: 'center',
                left: 280*2,
                top: 302*2,
                width: textMaxWidth,
              },
              true,
              true
            )
            if (len > 30) {
              const secondLine = this.lessonInfo.lessonName.slice(cutStr.length, len)
              ctx.render(
                secondLine,
                {
                  fontSize: '64px',
                  color: '#000',
                  lineHeight: '72px',
                  textAlign: 'center',
                  left: 280*2,
                  top: 348*2,
                  width: textMaxWidth,
                },
                true,
                true
              )
              // 绘制公开课ID
              const lessonId = this.$t('publesson.downloadImg.lessonId') + this.publessonId
              ctx.render(
                lessonId,
                {
                  fontSize: '48px',
                  color: '#666',
                  lineHeight: '72px',
                  textAlign: 'center',
                  left: 280*2,
                  top: 394*2,
                  width: textMaxWidth,
                },
                true,
                true
              )
              // 绘制开课时间
              ctx.render(
                this.$t('publesson.downloadImg.startTime') + this.lessonStartTime,
                {
                  fontSize: '48px',
                  color: '#666',
                  lineHeight: '72px',
                  textAlign: 'center',
                  left: 280*2,
                  top: 428*2,
                  width: textMaxWidth,
                },
                true,
                true
              )
              // 绘制授课教师
              ctx.render(
                this.$t('publesson.downloadImg.teacher') + this.lessonInfo.teacherName,
                {
                  fontSize: '48px',
                  color: '#666',
                  lineHeight: '72px',
                  textAlign: 'center',
                  left: 280*2,
                  top: 462*2,
                  width: textMaxWidth,
                },
                true,
                true
              )
              // 绘制扫码提示
              ctx.render(
                this.$t('publesson.downloadImg.scanCode'),
                {
                  fontSize: '48px',
                  color: '#B1B1B1',
                  lineHeight: '72px',
                  textAlign: 'center',
                  left: 280*2,
                  top: 784*2,
                  width: textMaxWidth,
                },
                true,
                true
              )
            } else {
              // 绘制公开课ID
              const lessonId = this.$t('publesson.downloadImg.lessonId') + this.publessonId
              ctx.render(
                lessonId,
                {
                  fontSize: '48px',
                  color: '#666',
                  lineHeight: '72px',
                  textAlign: 'center',
                  left: 280*2,
                  top: 348*2,
                  width: textMaxWidth,
                },
                true,
                true
              )
              // 绘制开课时间
              ctx.render(
                this.$t('publesson.downloadImg.startTime') + this.lessonStartTime,
                {
                  fontSize: '48px',
                  color: '#666',
                  lineHeight: '72px',
                  textAlign: 'center',
                  left: 280*2,
                  top: 382*2,
                  width: textMaxWidth,
                },
                true,
                true
              )
              // 绘制授课教师
              ctx.render(
                this.$t('publesson.downloadImg.teacher') + this.lessonInfo.teacherName,
                {
                  fontSize: '48px',
                  color: '#666',
                  lineHeight: '72px',
                  textAlign: 'center',
                  left: 280*2,
                  top: 416*2,
                  width: textMaxWidth,
                },
                true,
                true
              )
              // 绘制扫码提示
              ctx.render(
                this.$t('publesson.downloadImg.scanCode'),
                {
                  fontSize: '48px',
                  color: '#B1B1B1',
                  lineHeight: '72px',
                  textAlign: 'center',
                  left: 280*2,
                  top: 738*2,
                  width: textMaxWidth,
                },
                true,
                true
              )

            }
            // 绘制班级头像（圆角方形头像）
            const radiusRect  = (left, top, width, height, r) => {
              const pi = Math.PI;
              ctx.beginPath();
              ctx.arc(left + r, top + r, r, - pi, -pi / 2);
              ctx.arc(left + width - r, top + r, r, -pi / 2, 0);
              ctx.arc(left + width - r, top + height - r, r, 0, pi / 2);
              ctx.arc(left + r, top + height - r, r, pi / 2, pi);
              ctx.closePath();
            }
            radiusRect(236*2, 181*2, 90*2, 90*2, 10*2);
            ctx.clip();
            ctx.drawImage(_lessonImg, 236*2, 181*2, 90*2, 90*2)
            ctx.restore();
            // 绘制二维码
            const qr_img = new Image()
            qr_img.crossOrigin = 'Anonymous'
            qr_img.src = this.imgSrc
            qr_img.onload = () => {
              if (len > 30) {
                ctx.drawImage(qr_img, 176*2, 531*2, 208*2, 208*2)
              } else {
                ctx.drawImage(qr_img, 176*2, 485*2, 208*2, 208*2)
              }
              _this.canvasImgUrl = canvas.toDataURL("image/png")
            }
          }
        }
      }
    },
    // 计算字符串的字节数
    calculateLength(str) {
      var len = 0 
      for(var i =0; i< str.length; i++) {
        if(str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
            len += 2
        } else {
            len ++
        }
      }
      return len
    },
    // 根据字节数截取字符串
    cutStr(str, len) {
      var countLen = 0
      var resultLen = 0
      for(var i =0; i< str.length; i++) {
        if (countLen < len) {
          resultLen ++
          if(str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
            countLen += 2
          } else {
            countLen ++
          }
        } else {
          console.log('first--')
          break
        }
      }
      return str.slice(0, resultLen)
    }
  },
}
</script>

<style lang="less">
  .mask-img {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0,0,0,.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .container {
      display: flex;
      flex-direction: column;
      width: 280px;
      height: 406px;
      border-radius: 4px;
      overflow: hidden;
      position: relative;
      &.higher {
        height: 429px;
      }
      .save-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    .tip-text {
      margin-top: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }
    .close {
      margin-top: 15px;
      color: #fff;
      font-size: 30px;
      cursor: pointer;
    }

    &.mask-img-m {
      .container {
        width: 560px;
        height: 812px;
        border-radius: 8px;
        &.higher {
          height: 858px;
        }
      }
      .tip-text {
        margin-top: 48px;
        font-size: 28px;
      }
      .close {
        margin-top: 30px;
        font-size: 60px;
      }
    }
  }
</style>